import { TECHNICAL_EQUIPMENT } from "utils/constants";
import { createExporter } from "utils/createExporter";

const fileName = TECHNICAL_EQUIPMENT.replace(/[-/]/g, "_");

export const TechnicalEquipmentExporter = createExporter(`administration_${fileName}.xlsx`,
    [
        { key: "nameBg", label: "име" },
        { key: "model", label: "модел" },
        { key: "manufacturer", label: "производител" },
        { key: "serialNumber", label: "сериен номер" },
        { key: "inventoryNumber", label: "инвентарен номер" },
        { key: "description", label: "описание" }
    ],
    (record) => ({
        ...record,
    })
); 